let users = [
  {
    userid: "1667131239361",
    name: "Anand Thakur",
    city: "Delhi",
    from: "Agra",
    dob: "2002-01-01",
    relationship: "Single",
    profilePicture:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8cmFuZG9tJTIwcGVvcGxlfGVufDB8fDB8fA%3D%3D&w=1000&q=80",
    friends: [
      "1667152034165",
      "16671520845708545",
      "1667152611328",
      "1667152794902",
    ],
  },
  {
    userid: "1667152034165",
    name: "Darshak",
    city: "Mumbai",
    from: "Hyderabad",
    dob: "2002-01-01",
    relationship: "Married",
    profilePicture:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8cmFuZG9tJTIwcGVvcGxlfGVufDB8fDB8fA%3D%3D&w=1000&q=80",
    friends: [
      "1667152034165",
      "16671520845708545",
      "1667152611328",
      "1667152794902",
    ],
  },
  {
    userid: "16671520845708545",
    name: "Meet Jain",
    city: "Chennai",
    from: "Kolkata",
    dob: "2002-01-01",
    relationship: "Single",
    profilePicture:
      "https://tse3.mm.bing.net/th?id=OIP.WkuGv4-iR5uPKZFcs7UjvAHaHs&pid=Api&P=0",
    friends: [
      "1667152034165",
      "1667131239361",
      "1667152611328",
      "1667152794902",
    ],
  },
  {
    userid: "1667152611328",
    name: "Ajay",
    city: "Lucknow",
    from: "Varanasi",
    dob: "2002-01-01",
    relationship: "Single",
    profilePicture:
      "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8cmFuZG9tJTIwcGVvcGxlfGVufDB8fDB8fA%3D%3D&w=1000&q=80",
    friends: [
      "1667152034165",
      "16671520845708545",
      "1667131239361",
      "1667152794902",
    ],
  },
  {
    userid: "1667152794902",
    name: "Aman",
    city: "Pune",
    from: "Shimla",
    dob: "2002-01-01",
    relationship: "Single",
    profilePicture:
      "https://images.unsplash.com/photo-1499996860823-5214fcc65f8f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8cmFuZG9tJTIwcGVyc29ufGVufDB8fDB8fA%3D%3D&w=1000&q=80",
    friends: [
      "1667152034165",
      "16671520845708545",
      "1667152611328",
      "1667152794902",
    ],
  },
];
export default users;
